module.exports = __webpack_public_path__ + "img/语义检测.d35729a7.jpg";